module.exports = __webpack_public_path__ + "img/pay.5e2e6f33.png";